import React from 'react';
import { CheckCircle, ArrowLeft } from 'lucide-react';
import { globalSettings } from '@/hooks/useContent';

const Success = () => {
  const colors = globalSettings.colors;

  return (
    <div 
      className="min-h-screen flex items-center justify-center px-6"
      style={{ backgroundColor: colors.secondary }}
      data-testid="success-page"
    >
      <div className="max-w-2xl mx-auto text-center">
        {/* Success Icon */}
        <div 
          className="inline-flex items-center justify-center w-20 h-20 rounded-full mb-8"
          style={{ backgroundColor: `${colors.primary}20` }}
        >
          <CheckCircle 
            size={48} 
            style={{ color: colors.primary }}
          />
        </div>

        {/* Heading */}
        <h1 
          className="text-4xl md:text-5xl font-bold mb-6"
          style={{ color: colors.text }}
          data-testid="success-heading"
        >
          Your inquiry is in safe hands.
        </h1>

        {/* Body Text */}
        <p 
          className="text-lg md:text-xl mb-10 leading-relaxed"
          style={{ color: '#736c64' }}
          data-testid="success-body"
        >
          Thank you for choosing Nibbled. We are already preparing to make your event extraordinary. 
          One of our team members will reach out to you within 24 hours to finalise the details.
        </p>

        {/* Back to Home Button */}
        <a 
          href="/"
          className="inline-flex items-center gap-2 px-8 py-4 rounded-md font-semibold text-lg transition-all duration-300 hover:opacity-90"
          style={{ 
            backgroundColor: colors.primary,
            color: '#FFFFFF'
          }}
          data-testid="back-to-home-btn"
        >
          <ArrowLeft size={20} />
          Back to Home
        </a>

        {/* Additional Info */}
        <p 
          className="mt-8 text-sm"
          style={{ color: '#736c64' }}
        >
          Questions? Contact us at{' '}
          <a 
            href="mailto:hello@nibbled.co.za"
            className="underline hover:no-underline"
            style={{ color: colors.primary }}
          >
            hello@nibbled.co.za
          </a>
        </p>
      </div>
    </div>
  );
};

export default Success;
